import { WixSdkAdapter } from '@wix/cashier-common/dist/src/utils/WixSdkAdapter';
import { captureError } from './errorReporter';

export const wixSdkAdapter = new WixSdkAdapter({ captureError });
